import { UpdateCommunityHeaderProps } from "./types";

const UpdateCommunityHeader = ({ handleClose, clickUpd, disabled }: UpdateCommunityHeaderProps) => {
  return (
    <div className="add-comunity-header-1">
      <div className="cancle" onClick={handleClose}>
        취소
      </div>
      <div className="text">글 쓰기</div>
      <div
        className={disabled ? "disable-confirm" : "confirm"}
        onClick={disabled ? () => {} : clickUpd}
      >
        수정
      </div>
    </div>
  );
};

export default UpdateCommunityHeader;
